import { useState } from 'react';
import { Check, ChevronsUpDown } from 'lucide-react';
import { Button } from './ui/button';
import { Popover, PopoverContent, PopoverTrigger } from './ui/popover';
import { Command, CommandEmpty, CommandGroup, CommandInput, CommandItem, CommandList } from './ui/command';
import { cn } from '../lib/utils';

// Searchable vendor picker: typing filters by partial name match; selecting only stages the
// choice (caller shows an explicit Submit/Link button) rather than applying instantly.
export function VendorCombobox({ vendors, value, onSelect, placeholder = 'Search vendor...', testId }) {
  const [open, setOpen] = useState(false);
  const selected = vendors.find(v => v.zoho_vendor_id === value);

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button
          variant="outline"
          role="combobox"
          aria-expanded={open}
          className="w-64 justify-between h-8 text-xs rounded-sm font-normal"
          data-testid={testId}
        >
          <span className="truncate">{selected ? selected.vendor_name : placeholder}</span>
          <ChevronsUpDown className="ml-2 h-3.5 w-3.5 shrink-0 opacity-50" />
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-64 p-0">
        <Command>
          <CommandInput placeholder="Type vendor name..." className="text-sm" data-testid={testId ? `${testId}-search` : undefined} />
          <CommandList>
            <CommandEmpty>No vendor found.</CommandEmpty>
            <CommandGroup>
              {vendors.map(v => (
                <CommandItem
                  key={v.zoho_vendor_id}
                  value={v.vendor_name}
                  onSelect={() => { onSelect(v.zoho_vendor_id); setOpen(false); }}
                  data-testid={testId ? `${testId}-option-${v.zoho_vendor_id}` : undefined}
                >
                  <Check className={cn('mr-2 h-4 w-4', value === v.zoho_vendor_id ? 'opacity-100' : 'opacity-0')} />
                  <span className="truncate">{v.vendor_name}</span>
                  {v.country && <span className="text-[10px] text-muted-foreground ml-1.5 shrink-0">({v.country})</span>}
                </CommandItem>
              ))}
            </CommandGroup>
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  );
}
